import axios from 'axios';
import qs from 'qs';
import { router } from '@/main';

const defaultConfig = {
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
    },
    data: {},
    getData: {},
    postData: {},
    params: {},
    responseType: 'json',
    credentials: 'same-origin',
    validateStatus() {
        return true;
    },
};
let onBeforeSend = [];
const hook403 = () => {
    // router.push({ name: 'index' });
};
const hook404 = () => {
    // router.push('/manage/error/404');
};
const hookError = () => {};

function checkResponse(res) {
    if (res.status >= 200 && res.status < 300) {
        return res.data;
    }
    if (res.status === 403) {
        hook403(res);
        return false;
    }
    if (res.status === 404) {
        hook404(res);
        return false;
    }
    hookError(res);
    return false;
}

const request = {
    init: (config) => {
        if (config.headers) {
            Object.assign(defaultConfig.headers, config.headers);
        }
        if (config.getData) {
            Object.assign(defaultConfig.getData, config.getData);
        }
        if (config.postData) {
            Object.assign(defaultConfig.postData, config.postData);
        }
        if (config.onBeforeSend) {
            onBeforeSend = [...config.onBeforeSend];
        }
    },
    send: async (reqItem) => {
        const sendOptions = Object.assign({}, defaultConfig, reqItem);
        if (reqItem.headers) {
            Object.assign(sendOptions.headers, defaultConfig.headers);
        }
        if (!reqItem.data) {
            reqItem.data = {};
        }
        if (reqItem.method && reqItem.method.toUpperCase() !== 'GET') {
            sendOptions.data = qs.stringify({ ...defaultConfig.data, ...defaultConfig.postData, ...reqItem.data });
        } else {
            sendOptions.params = { ...defaultConfig.data, ...defaultConfig.getData, ...reqItem.data };
            sendOptions.data = {};
        }

        const beforeSendFunc = onBeforeSend.concat(reqItem.onBeforeSend);
        const beforeResult = beforeSendFunc.reduce((result, cur) => {
            if (cur instanceof Function) {
                return result && cur(reqItem);
            }
            return result;
        }, true);

        if (!beforeResult) {
            console.log('before send error!');
            return Promise.reject(reqItem, null);
        }

        const res = await axios({ url: reqItem.url, ...sendOptions });
        const resBody = checkResponse(res);

        if (resBody) {
            return Promise.resolve(resBody);
        }
        return Promise.reject(res);
    },
};

export default request;
